<template>
  <div class="job-details">
    <div class="job-details-overlay" :show="show" @click="hiddenMask">
      <div class="job-details-wrapper" @click.stop>
        <div class="tab-wrap">
          <div class="return-wrap" @click="hiddenMask">
            <Icon class="return" name="arrow-left" />
          </div>
          <div
            v-for="(item, index) in jobTitleArr"
            :key="index"
            class="tab-item"
            :class="{ 'tab-item-active': activeTab === index }"
            @click="tabClick(index)"
          >
            {{ item }}
          </div>
        </div>
        <van-swipe
          v-if="show"
          ref="swiper"
          :show-indicators="false"
          :touchable="true"
          @change="onChangeSwiper"
        >
          <van-swipe-item>
            <img class="img0" src="" alt="">
            <!-- <dom-screenshot ref="imageDom" dist-type="png"> -->
            <div class="job-intro-wrap">
              <div class="jin-title">金十数据</div>
              <div class="job-name">{{ details.name }}</div>
              <div class="job-type">{{ jobType }}</div>
              <div class="qrcode-wrap">
                <QrcodeVue class="qrcode" :value="href" :size="94" />
              </div>
              <div class="title">长按识别二维码查看职位</div>
              <div class="website">www.jin10.com</div>
            </div>
            <!-- </dom-screenshot> -->
            <div class="download-btn">
              <span>长按保存图片</span>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="job-scroll-wrap">
              <img class="img1" src="" alt="">
              <!-- <dom-screenshot ref="imageDom1" dist-type="png"> -->
              <div class="job-detail-wrap">
                <div class="job-content-wrap">
                  <PostHead />
                  <div class="jin-details-body">
                    <span
                      class="date"
                    >发布时间：{{
                      dayjs(details.display_datetime).format("YYYY/MM/DD")
                    }}</span>
                    <div class="jin-details-body-warp">
                      <div class="jin-details-body-item">
                        <p>岗位职责</p>
                        <ul>
                          <li v-html="details.duty" />
                        </ul>
                      </div>
                      <div class="jin-details-body-item">
                        <p>岗位要求</p>
                        <ul>
                          <li v-html="details.job_requirements" />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- </dom-screenshot> -->
            </div>
            <div class="download-btn">
              <span>长按保存图片</span>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="img-content" />
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import html2canvas from 'html2canvas'
// import domScreenshot from '@front-end/components/lib/dom-screenshot'

export default {
  components: {
    QrcodeVue
    // domScreenshot
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    jobInfo: {
      type: Object,
      default: () => {}
    },
    href: {
      type: String,
      default: ''
    },
    categoryInfo: {
      type: Array,
      default: () => []
    },
    details: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      jobTitleArr: ['职位概述', '职位详情'],
      activeTab: 0,
      jobType: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      const toImgArr = ['.job-intro-wrap', '.job-detail-wrap']
      toImgArr.forEach((className, i) => this.generateImages(className, i))
    })
    console.log('details', this.details)
    this.jobType = this.categoryInfo
      .find((item) => item.id === this.details.category_id)
      .name.slice(0, -1)
  },
  methods: {
    hiddenMask() {
      this.activeTab = 0
      this.$emit('update:show', false)
    },
    onChangeSwiper(index) {
      this.activeTab = index
    },
    tabClick(index) {
      this.activeTab = index
      this.$refs.swiper.swipeTo(index)
    },
    generateImages(className, i) {
      const el = document.querySelector(className)
      const imageEl = document.querySelector(`.img${i}`)
      html2canvas(el, {
        allowTaint: true,
        useCORS: true,
        scale: 8,
        dpi: window.devicePixelRatio * 8,
        // scrollY: el.top
        width: el.scrollWidth,
        height: i === 0 ? el.scrollHeight : el.scrollHeight + 10,
        // windowWidth: el.scrollWidth,
        // windowHeight: el.scrollHeight,
        backgroundColor: '#4777F4'
      }).then((canvas) => {
        const imgUrl = canvas.toDataURL('image/png', 1.0)
        imageEl.src = imgUrl
        el.style.display = 'none'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.job-details {
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  div {
    box-sizing: border-box;
  }
  .job-details-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 9999;
    .job-details-wrapper {
      .tab-wrap {
        display: flex;
        justify-content: space-between;
        width: 100%;
        height: 43px;
        line-height: 43px;
        padding: 0 90px 0 19px;
        background-color: #fff;
        .return-wrap {
          width: 18px;
          height: 18px;
        }
        .tab-item {
          position: relative;
          width: 59px;
          font-size: 14px;
          color: #787b8a;
          &::after {
            content: "";
            width: 36px;
            height: 3px;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0;
            background: #4777f4;
            border-radius: 2px;
          }
        }
        .tab-item-active {
          color: #4777f4;
          &::after {
            position: absolute;
          }
        }
      }
      .img0 {
        display: block;
        // width: 100%;
        width: 339px;
        height: auto;
        margin: 56px auto 0;
        border-radius: 9px;
      }
      .job-intro-wrap {
        // display: none!important;
        position: relative;
        left: 0;
        top: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 339px;
        height: 453px;
        margin: 0 auto;
        padding: 77px 0 24px;
        background: url("~@/assets/infoDetails/mobile/jobDetails/卡片@2x.png")
          no-repeat;
        background-size: 100% 100%;
        border-radius: 9px;
        overflow: hidden;
        z-index: -1;
        .jin-title {
          height: 14px;
          font-size: 14px;
          color: #ffffff;
          line-height: 22px;
        }
        .job-name {
          height: 18px;
          margin: 15px 0;
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
          line-height: 27px;
        }
        .job-type {
          height: 14px;
          font-size: 14px;
          color: #ffffff;
          line-height: 22px;
        }
        .qrcode-wrap {
          width: 94px;
          height: 94px;
          margin-top: 120px;
          background: #ffffff;
          // border-radius: 9px;
          // overflow: hidden;
          // border: 1px solid #4777F4;
        }
        .title {
          height: 12px;
          font-size: 12px;
          font-weight: 400;
          color: #3d4351;
          line-height: 18px;
        }
        .website {
          font-size: 12px;
          font-weight: 400;
          color: #787b8a;
          letter-spacing: 1px;
          transform: scale(0.5);
        }
      }
      .img1 {
        display: block;
        width: 100%;
        height: auto;
        margin: 0 auto;
        border-radius: 10px;
      }
      .job-scroll-wrap {
        // display: none!important;
        // opacity: 0;
        width: 339px;
        height: 472px;
        margin: 56px auto 0;
        overflow-y: scroll;
        background: #4777f4;
        border-radius: 10px;
      }
      .job-detail-wrap {
        position: relative;
        left: 0;
        top: 100vh;
        width: 339px;
        height: 472px;
        padding: 42px 18px 0;
        background: url("~@/assets/infoDetails/mobile/jobDetails/详情.png")
          no-repeat;
        background-size: 100% 100%;
        z-index: -1;
        // overflow: auto;
        .job-content-wrap {
          background: #ffffff;
          border-radius: 9px;
          overflow: hidden;
        }
        .jin {
          &-details {
            &-warp {
              background: #fff;
            }

            &-body {
              &-warp {
                border-bottom: 1px solid #e8e8ea;
              }

              .date {
                color: #787b8a;
              }

              &-item {
                p {
                  font-weight: 500;
                  color: #3d4351;
                }

                ul {
                  li {
                    color: #787b8a;
                  }
                }
              }
            }
          }
        }
      }
      .download-btn {
        margin: 27px auto 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 165px;
        height: 40px;
        // background: #4777f4;
        border-radius: 9px;
        img {
          width: 15px;
          height: 15px;
          margin-right: 5px;
        }
        span {
          height: 18px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 18px;
        }
      }
      .close-btn {
        width: 28px;
        height: 28px;
        margin: 2vh auto 0;
        background: url("~@/assets/infoDetails/mobile/jobDetails/icon-close.png")
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>
